var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ThemeProvider, } from '@mui/material';
import { Button } from './Button';
import { theme } from '../theme';
var ID_COMPONENT = 'confirm-dialog-generic';
export var ConfirmDialog = function (_a) {
    var _b = _a.title, title = _b === void 0 ? null : _b, _c = _a.content, content = _c === void 0 ? null : _c, _d = _a.form, form = _d === void 0 ? null : _d, _e = _a.color, color = _e === void 0 ? null : _e, _f = _a.isOnlyInfo, isOnlyInfo = _f === void 0 ? false : _f;
    return new Promise(function (resolve) {
        addDialog({ title: title, content: content, form: form, color: color, isOnlyInfo: isOnlyInfo }, resolve);
    });
};
var GetValue = function (_a) {
    var resolve = _a.resolve, content = _a.content, title = _a.title, form = _a.form, color = _a.color, isOnlyInfo = _a.isOnlyInfo;
    var _b = React.useState({}), params = _b[0], setParams = _b[1];
    function clickOK() {
        removeDialog();
        if (!isOnlyInfo) {
            resolve({ isOk: true, params: params });
        }
        else {
            resolve();
        }
    }
    function clickCancel() {
        removeDialog();
        if (!isOnlyInfo) {
            resolve({ isOk: false, params: params });
        }
        else {
            resolve();
        }
    }
    var nameColor = color ? color : 'primary';
    var styleColor = {
        backgroundColor: theme.palette[nameColor].main,
        color: theme.palette[nameColor].contrastText,
    };
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsxs(Dialog, __assign({ id: ID_COMPONENT, open: true, onClose: clickCancel, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" }, { children: [title && (_jsx(DialogTitle, __assign({ sx: styleColor, id: "alert-dialog-title" }, { children: title }))), _jsx(DialogContent, { children: _jsxs(DialogContentText, __assign({ id: "alert-dialog-description", sx: { paddingTop: 2 } }, { children: [content, form ? form({ params: params, setParams: setParams }) : null] })) }), _jsxs(DialogActions, { children: [!isOnlyInfo && (_jsx(Button, __assign({ color: "neutre", onClick: clickCancel }, { children: "Annuler" }))), _jsx(Button, __assign({ color: nameColor, onClick: clickOK }, { children: isOnlyInfo ? 'OK' : 'Valider' }))] })] })) })));
};
var addDialog = function (props, resolve) {
    var body = document.getElementsByTagName('body')[0];
    var div = document.createElement('div');
    div.setAttribute('id', "".concat(ID_COMPONENT, "-container"));
    body.appendChild(div);
    var root = createRoot(div);
    root.render(_jsx(React.StrictMode, { children: _jsx(GetValue, __assign({}, props, { resolve: resolve })) }));
};
var removeDialog = function () {
    var div = document.getElementById("".concat(ID_COMPONENT, "-container"));
    var divDialog = document.getElementById(ID_COMPONENT);
    var body = document.getElementsByTagName('body')[0];
    body.removeChild(div);
    body.removeChild(divDialog);
    body.style = '';
};
//# sourceMappingURL=ConfirmDialog.js.map